module.exports = __webpack_public_path__ + "images/category_lp/pc/voice_2526fc840a37a2796cdac3ae489a9db0.png";